export default theme => ({
  content: {
    // flex: 0.6,
    overflowX: "hidden",
    overflowY: "auto"
  },
  paper: {
    display: "flex",
    flexDirection: "column",
    height: "100%",
    padding: theme.spacing(3)
  }
});
